import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Table } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import FloatingButton from "../../../../components/floatingButton/FloatBtn";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import styles from "../SingleAssets/singleasset.module.css";

const Pending = ({
  add_asset,
  is_immobilized,
  user,
  setActiveTab,
  pair_unpair_device,
}) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [afterDispatch, setAfterDispatch] = useState(true);
  const [details, setDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [connectModal, setConnectModal] = useState(false);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openUploadAsset, setOpenUploadAsset] = useState(false);

  const getPendingAssets = useSelector(
    (state) => state.AssetsReducer?.getPendingAssets,
  );
  const reports = user?.permissions?.find((x) => x?.name == "reports");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await dispatch(AssetsMiddleware.getPendingAssets());
  };

  useEffect(() => {
    if (!afterDispatch) setOpen(false);
  }, [!afterDispatch]);

  const onExportAssest = async () => {
    await dispatch(AssetsMiddleware.exportAssets()).then((data) => {
      const url = data?.data?.data?.url;
      if (url) {
        window.open(url, "_blank");
      }
    });
  };

  const onDeletePending = (data) => {
    dispatch(AssetsMiddleware.deletePendingAssets({ id: data?.id })).then(
      () => {},
    );
  };
  const pagecalculation = () => {
    if (!getPendingAssets?.meta) {
      return 0;
    }
    return (
      (getPendingAssets?.meta?.current_page - 1) *
      getPendingAssets?.meta?.per_page
    );
  };

  const items2 = [
    {
      key: "3",
      label: <a onClick={() => setOpenEditAssetsModal(true)}>Edit details</a>,
    },
    {
      key: "4",
      label: (
        <a
          onClick={() => {
            setOpen(false);
            setDeleteModal(true);
          }}
        >
          Delete vehicle
        </a>
      ),
    },
  ];

  const PendingDelete = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, data, index) => (
        <div className={styles.dealerDiv}>
          <SubmitButton
            title={"Delete Pending"}
            className={styles.deleteBtn}
            onClick={() => {
              onDeletePending(data);
            }}
          />
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent
            text={`${pagecalculation() + index + 1}`}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Pic",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => (
        <div className={styles.module}>
          <TextComponent text={data ? data : "-"} className={styles.text} />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock_no",
      key: "stock_no",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (text) => {
        const lastEight = text ? text.toString().slice(-8) : "-";

        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={lastEight} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Make",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent
            text={data?.make ? data?.make : "-"}
            className={styles.text}
          />
        </div>
      ),
    },

    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (text) => (
        <div>
          <TextComponent
            text={text ? text : "-"}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Odometer",
      dataIndex: "odometer",
      key: "odometer",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Day In Inventory",
      dataIndex: "days_in_inventory",
      key: "days_in_inventory",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    // {
    //   title: "Lot Name",
    //   dataIndex: "lot_no",
    //   key: "lot_no",
    //   render: (text) => {
    //     return (
    //       <div className={styles.dealerDiv}>
    //         <TextComponent text={text ? text : "-"} className={styles.text} />
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Year",
    //   dataIndex: "year",
    //   key: "battery",
    //   render: (text) => (
    //     <div className={styles.batteryDiv}>
    //       {/* <img src={item?.image} className={styles.moduleImg} /> */}
    //       {/* <BatteryStatus percentage={text} /> */}
    //       <TextComponent text={text} className={styles.text} />
    //     </div>
    //   ),
    // },
    {
      title: "License Plate",
      dataIndex: "license_no",
      key: "license_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text ? text : "-"} className={styles.text} />
        </div>
      ),
    },

    {
      title: "Trim",
      dataIndex: "trim",
      key: "trim",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },

    // {
    //   title: "Track",
    //   dataIndex: "track",
    //   key: "track",
    //   render: (text) => (
    //     <div
    //       className={styles.trackDiv}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // setLocationTracking(true);
    //       }}
    //     >
    //       {text}
    //     </div>
    //   ),
    // },
  ];

  const baseButtons = [
    {
      title: "Add vehicle",
      onClick: () => setOpenAddAssetsModal(true),
    },
    {
      title: "Add vehicle group",
      onClick: () => setOpenAddGroupAsset(true),
    },
    {
      title: "Upload vehicle",
      onClick: () => setOpenUploadAsset(true),
    },
  ];

  const buttons =
    reports?.is_access === 0
      ? baseButtons
      : [
          ...baseButtons,
          {
            title: "Export vehicle",
            onClick: onExportAssest,
          },
        ];

  return (
    <>
      <div className={styles.tableHeader}>
        {user?.is_owner || add_asset?.is_access == 1 ? (
          <FloatingButton
            Buttons={buttons}
            floatStyle={styles.floatingBtn}
            buttonStyles={styles.floatingButtonsContainer}
          />
        ) : null}
      </div>
      <div className={styles.tableDiv}>
        <Table
          scroll={{ x: true }}
          bordered={false}
          pagination={{
            showSizeChanger: false,
            showQuickJumper: false,
            current: getPendingAssets?.meta?.current_page,
            pageSize: getPendingAssets?.meta?.per_page,
            total: getPendingAssets?.meta?.total,
            onChange: (page, pageSize) => {
              dispatch(
                AssetsMiddleware.getPendingAssets({
                  url: `${getPendingAssets?.meta?.path}?page=${page}`,
                }),
              );
            },
            itemRender: (_, type, originalElement) => {
              if (type === "prev") {
                return (
                  <span
                    style={{
                      color: getPendingAssets?.links?.prev ? "inherit" : "#ccc",
                      cursor: getPendingAssets?.links?.prev
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getPendingAssets({
                          url: getPendingAssets?.links?.prev,
                        }),
                      );
                    }}
                  >
                    <LeftOutlined /> Prev
                  </span>
                );
              }
              if (type === "next") {
                return (
                  <span
                    style={{
                      color: getPendingAssets?.links?.next ? "inherit" : "#ccc",
                      cursor: getPendingAssets?.links?.next
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getPendingAssets({
                          url: getPendingAssets?.links?.next,
                        }),
                      );
                    }}
                  >
                    Next <RightOutlined />
                  </span>
                );
              }
              return originalElement;
            },
          }}
          columns={[...columns, ...PendingDelete]}
          dataSource={getPendingAssets?.data}
        />

        {/* {user?.is_owner || add_asset?.is_access == 1 ? (
          <FloatingButton Buttons={buttons} />
        ) : null} */}

        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false);
          }}
          icon={
            <AiOutlineQuestionCircle
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          twoButton
          okBtnTitle={"Yes, delete"}
          cancelBtnTitle={"No, go back"}
          title={"Are you sure"}
          text={"You want to delete this vehicle?"}
          width={400}
          // btnDiv={styles.access_modalBtn}
          onClickCancelButton={() => {
            setDeleteModal(false);
          }}
          onClickOkButton={
            () => {
              dispatch(AssetsMiddleware.deleteAssets(details?.id)).then(() => {
                setDeleteModal(false);
                setSuccess(true);
              });
            }
            //   () => {
            //   setSuccess(true);
            //   setDeleteModal(false);
            // }
          }
          headingClass={styles.modalHeading}
        ></Modal>
        <Modal
          open={success}
          onCancel={() => setSuccess(false)}
          icon={
            <PiSealCheck
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Vehicle Deleted successfully"}
          width={"300px"}
          buttonTitle={"Continue"}
          onBtnPress={() => {
            setSuccess(false);
          }}
          headingClass={styles.modalHeading}
        ></Modal>
      </div>
    </>
  );
};

export default Pending;
